export interface Problem {
  tag: string;
  title: string;
  body: string;
}

export const problems: Problem[] = [
  {
    tag: "The whiteboard",
    title: "A compiler team asks candidates to explain SSA on a whiteboard.",
    body: "What they actually need to know is whether this person can write a real LLVM pass against live IR. Those are completely different skills.",
  },
  {
    tag: "The algorithms screen",
    title: "A platform team runs Kubernetes interviews on a generic coding platform.",
    body: "It has no idea what a controller reconcile loop is. So they hire on theory and find out the rest in onboarding.",
  },
  {
    tag: "The take-home",
    title: "An embedded team sends a take-home. Half of candidates don't finish.",
    body: "The ones who do — the team can't tell whether they wrote it themselves or had an LLM do it. Either way, you're guessing.",
  },
];
